import PropTypes from 'prop-types';
import get from 'lodash/get';
import GuideItemLink from '../shared/GuideItemLink';
import ClampText from '../../shared/ClampText';
import ImageWithDefault from '../../shared/ImageWithDefault';
import assetUrl from '../../../utils/assetUrl';
import { validateAndGetHexColor } from '../../../utils/color';
import vars from '../../../styles/variables';
import css from './wideTextTile.module.scss';

const fallbackImgSrc = assetUrl('assets/img/tile-pattern.svg');

const flexVertMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

const textAlignMap = {
  left: 'left',
  center: 'center',
  right: 'right',
};

const WideTextTile = ({ guideItem, index, getStyles }) => {
  const bgImage = get(guideItem, 'properties.backgroundImage.imageUrl');
  const itemStyleName = get(guideItem, 'style');
  const styles = getStyles(itemStyleName);
  const colorFromStyles = styles.textColor;
  const colorPalette = styles.textColorPalette;
  let textColor;

  if (colorFromStyles) {
    textColor = validateAndGetHexColor(styles.textColor, vars['--white']);
  } else if (colorPalette) {
    const colorIndex = index % colorPalette.length;
    textColor = validateAndGetHexColor(
      colorPalette[colorIndex],
      vars['--white'],
    );
  } else {
    textColor = vars['--white'];
  }

  const horizontalAlignment =
    textAlignMap[styles.tileTitleAlignment] || textAlignMap.left;
  const verticalAlignment =
    flexVertMap[styles.tileTitleVerticalAlignment] || flexVertMap.bottom;

  return (
    <GuideItemLink
      className={css.wideTextTile}
      guideItem={guideItem}
      dataTestId="wideTextTile"
    >
      <ImageWithDefault
        dataTestId="guideItemImage"
        src={bgImage}
        placeholder={fallbackImgSrc}
        alt={guideItem.title}
        className={css.image}
      />
      <div
        style={{
          justifyContent: verticalAlignment,
        }}
        className={css.titleWrapper}
      >
        <div
          style={{ color: textColor, textAlign: horizontalAlignment }}
          className={css.clampTextWrapper}
        >
          <ClampText clamp={2} className={css.title}>
            {guideItem.title}
          </ClampText>
        </div>
      </div>
    </GuideItemLink>
  );
};

WideTextTile.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  getStyles: PropTypes.func.isRequired,
};

export default WideTextTile;
